import { DataType } from "@dndModels/Types";
import { ColorsType } from "../DandDPalette";
import { UpsertableBase } from "@models/UpsertableBase";
import { Campaign, CampaignPlayer, Character } from "@dndModels";

export class User extends UpsertableBase {
  data_type: DataType = "user";
  auth_id = "";
  email = "";
  dm = false;
  admin = false;
  is_admin = false;
  campaign_ids: string[] = []; 
  // _ids of all source_books that they have access to
  purchased_sb_ids: string[] = [];
  shared_sb_ids: string[] = [];
  free_sb_ids: string[] = []; 
  name = "";
  view_blocked_source_books = false;
  hide_info: string[] = [];
  profile_name = "";
  c_players: CampaignPlayer[] = []; // This is all the records of campaigns this user is a player for. Used for figuring out shared_sb_ids.
  owned_campaigns: Campaign[] = [];
  get owned_campaign_ids() {
    return this.owned_campaigns.map(o => o._id);
  } 
  playing_campaigns: Campaign[] = []; // I'm going to make it populate these at the same time as c_players, and then it can just pull from this when it needs to.
  // I'm going to make it so these only get loaded once. 
  // They can be left blank until they're needed, and then just pull from this when needed.
  get my_campaigns() {
    return [...this.owned_campaigns,...this.playing_campaigns];
  }
  my_characters: Character[] = [];

  get use_name() {
    if (this.name === "") {
      return this.profile_name;
    } else {
      return this.name;
    }
  }

  get_display_format() {
    return this.use_name;
  }

  get source_book_ids() {
    return [...this.purchased_sb_ids, ...this.shared_sb_ids,...this.free_sb_ids];
  }
  
  colors_for: {
    [for_id: string]: ColorsType
  } = {};

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.auth_id = obj.auth_id ? obj.auth_id : "";
      this.email = obj.email ? obj.email : "";
      this.name = obj.name ? obj.name : (obj.username ? obj.username : "");
      this.profile_name = obj.profile_name ? obj.profile_name : "";
      this.dm = obj.dm ? obj.dm : false;
      this.is_admin = obj.is_admin ? obj.is_admin : (obj.admin ? obj.admin : false);
      // this.admin = this.is_admin; // Comment for deploys.
      this.purchased_sb_ids = obj.purchased_sb_ids ? obj.purchased_sb_ids : [];
      this.campaign_ids = obj.campaign_ids ? obj.campaign_ids : [];
      this.shared_sb_ids = []; 
      this.view_blocked_source_books = obj.view_blocked_source_books ? obj.view_blocked_source_books : false;
      this.colors_for = obj.colors_for ? obj.colors_for : {};
      this.hide_info = obj.hide_info ? obj.hide_info : [];
    }
  }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      auth_id: this.auth_id,
      email: this.email,
      name: this.name,
      profile_name: this.profile_name,
      dm: this.dm,
      admin: this.is_admin,
      campaign_ids: this.campaign_ids,
      purchased_sb_ids: this.purchased_sb_ids,
      // shared_sb_ids: this.shared_sb_ids,
      colors_for: this.colors_for,
      view_blocked_source_books: this.view_blocked_source_books,
      hide_info: this.hide_info,
    };
  }

  copy(copyMe: User, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.auth_id = copyMe.auth_id;
    this.email = copyMe.email;
    this.name = copyMe.name;
    this.profile_name = copyMe.profile_name;
    this.dm = copyMe.dm;
    this.admin = copyMe.admin;
    this.is_admin = copyMe.is_admin;
    this.campaign_ids = [...copyMe.campaign_ids];
    this.purchased_sb_ids = [...copyMe.purchased_sb_ids];
    this.shared_sb_ids = [...copyMe.shared_sb_ids];
    this.colors_for = {...copyMe.colors_for}; 
    this.view_blocked_source_books = copyMe.view_blocked_source_books;
    this.hide_info = [...copyMe.hide_info];
  }

  clone(drop_ids = false): User {
    const new_obj = new User();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

// export class UserOwnership extends UpsertableBase {
//   data_type: DataType = "user_ownership";
//   user_id = "";
//   object_type: PlayerObjectType = "player_object";
//   object_id = "";

//   constructor(obj?: any) {
//     super(obj);
//     if (obj) {
//       this.user_id = obj.user_id ? obj.user_id : "";
//       this.object_type = obj.object_type ? obj.object_type : "player_object";
//       this.object_id = obj.object_id ? obj.object_id : "";
//     }
//   }

//   get linkURL() {
//     const linkUrl = `/${this.data_type}/${this._id}`;
//     return linkUrl;
//   }

//   get use_name() {
//     return this.name;
//   }

//   get archived() {
//     return false;
//   }
//   get_display_format(): string {
//     return this.name;
//   }

//   get_detail_format(): string {
//     return "";
//   }
//   detailFormat() {
//     return this.get_detail_format();
//   }

//   toDBObj(): any {
//     const super_obj = super.toDBObj();
//     return {
//       ...super_obj,
//       user_id: this.user_id,
//     };
//   }
  
//   copy(copyMe: UserOwnership, drop_ids = false): void {
//     super.copy(copyMe, drop_ids);
//     this.user_id = copyMe.user_id;
//     this.object_type = copyMe.object_type;
//     this.object_id = copyMe.object_id;
//   }

//   clone(drop_ids = false): UserOwnership {
//     const new_obj = new UserOwnership();
//     new_obj.copy(this, drop_ids);
//     return new_obj;
//   }
// }